import React from 'react';
import './LoadingInside.css';  // Zaimportuj styl CSS
import CachedIcon from '@mui/icons-material/Cached';
import SendIcon from '@mui/icons-material/Send';
import StopIcon from '@mui/icons-material/Stop';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { IconButton } from '@mui/material';

const LoadingInside = ({ state="ready", onSend }) => {
  // if (!isLoading) return null;
  // const state = 'run'
  return (
    <div style={{zIndex: 1300, width: '80px', height: '80px', alignContent: 'center'}}>
      {state === 'run' || state === 'wait' ? 
      <div style={{position: 'relative'}}>
        <div style={{ zIndex: '2', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        <IconButton  disabled={state === 'wait'} onClick={onSend} >
          {state === 'run' && <StopIcon sx={{ marginLeft: '-7px', fontSize: 50, color: '#4383e3' }} />}
          {state === 'wait' && <HourglassTopIcon sx={{ marginLeft: '-7px', fontSize: 40, color: '#4383e3' }} />}
        </IconButton>
        </div>  
        <div class="spinner_inside_start">
          
          <button type="button" className='button_start'>
              
          </button>
        </div>
      </div>
      :
      <div>
        <button type="button" onClick={onSend} className='button_start' style={{    
          placeContent: 'center',
          display: 'grid'}}>
        <IconButton  >
          {state === 'ready' && <SendIcon  sx={{ marginLeft: '5px', fontSize: 40, color: '#4383e3' }} />}
          {state === 'error' && <CachedIcon  sx={{ fontSize: 50, color: '#4383e3' }} />}
        </IconButton>
        </button>
      </div>
      }
    </div>
  );
};

export default LoadingInside;
